import { ReactNode } from 'react'
import Footer from '../components/Footer'
import Header from '../components/Header'
import ReportHeader from '../components/Report/Header'

type Props = {
    report?: boolean
    maintenance?: boolean
    children: ReactNode
}

const Layout = ({ report, maintenance, children }: Props) => {
    return (
        <>
            {report ? <ReportHeader /> : <Header />}
            <div className={maintenance ? 'container-maintenance' : 'container'}>{children}</div>
            {<Footer />}
        </>
    )
}

export default Layout
